//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQListParameters from "@/components/SmartContractDesigner/SCComponents/AQListParameters.vue";

export default {
    components: {
        AQInput,
        AQButton,
        AQDropdown,
        AQModal,
        AQDialog,
        AQListParameters
    },
    props: {
        elementIndex: {
            type: Number
        },
        readonly: {
            type: Boolean
        },
        value: Object
    },
    data() {
        return {
            blockchainModal: false,
            noSCErr: false,
            noFncErr: false,
            description: null,
            contract: null,
            func: null,
            saveDisabled: true,
            dialogOpen: false,
            functionData: null,
            functionDataMap: null,
            messageTitle: this.$t("smartContract.confirmationDialog.msg2"),
            titleDialog: this.$t("smartContract.confirmationDialog.title"),
            blockchain: true,
            requestNoMap: false,
            mappedArrayRequest: [],
            mappedArrayResponse: [],
            defaultValueFunc: "",
            defaultValueContract: ""
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "modelForProcessDefinition", "scDetailsFunction"]),
        primaryBtn() {
            return { label: this.$t("generic.done"), disabled: this.saveDisabled };
        },
        ddlSelectContract() {
            return {
                options: this.contractsForDdl,
                fitParentContainer: true,
                errorLabel: this.$t("errorRequired")
            };
        },

        ddlSelectFunction() {
            return {
                options: this.functionsForDdl,
                fitParentContainer: true,
                errorLabel: this.$t("errorRequired")
            };
        },

        contractsForDdl() {
            let contracts = [];
            if (this.scDetailsFunction.length) {
                contracts = this.scDetailsFunction.map(contract => ({
                    value: contract.id,
                    label: contract.name
                }));
            }
            return contracts;
        },

        functionsForDdl() {
            let functions = [];
            if (this.scDetailsFunction.length && this.contract && this.contract.length) {
                const contractSelected = this.scDetailsFunction.find(el => el.id === this.contract);
                if (contractSelected && contractSelected.functionSignatureDtoList) {
                    functions = contractSelected.functionSignatureDtoList.map(fct => ({
                        value: fct.id,
                        label: fct.name,
                        functionSign: fct
                    }));
                }
            }
            return functions;
        }

    },
    watch: {
        selectedPluginData(newVal) {
            if (newVal) {
                this.func = null;
                this.contract = null;
                this.description = null;
                this.selectPlugin(newVal);
            }
        }

    },

    created() {
        this.$root.$on("disable", value => {
            this.saveDisabled = value;
        });
    },

    mounted() {
        this.selectPlugin();
    },

    methods: {
        okAction() {
            this.blockchainModal = false;
        },
        action(action) {
            if (action === "close") {
                this.hide(action);
            } else if (action === "primary") {
                if (!this.readonly) {
                    this.$root.$emit("showCheckedSaveBtn", false);
                    const inParams = this.prepareRequestResponse(this.functionData.inParameters, "request");
                    const outParams = this.prepareRequestResponse(this.functionData.outParameters, "response");
                    this.$set(this.functionDataMap, "request", this.mappedArrayRequest);
                    this.$set(this.functionDataMap, "response", this.mappedArrayResponse);
                    const obj = {
                        id: this.func,
                        contractId: this.contract,
                        inParameters: inParams,
                        outParameters: outParams
                    };
                    this.$emit("input", obj);
                    this.hide(action);
                    if (this.requestNoMap) {
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("smartContract.callHandler.saveWarning"),
                            timeout: 1000
                        });
                    }
                }
            }
        },

        hide(evt) {
            if (!this.saveDisabled && evt === "close") {
                this.dialogOpen = true;
            } else {
                this.blockchainModal = false;
            }
        },
        prepareResponseRequest(object) {
            let index = 0;
            const array = [];
            Object.entries(object).forEach(([key, value]) => {
                const element = {
                    index,
                    parameterId: key,
                    variableName: value,
                    variableValue: value
                };
                array.push(element);
                index++;
            });
            return array;
        },

        openModal() {
            if (this.functionData || this.selectedPluginConfigData.functionId || this.selectedPluginConfigData.blockchainFunction) {
                const findFunction = this.functionsForDdl.find(el => el.value === this.func);
                if (findFunction && findFunction.functionSign) {
                    this.functionData = findFunction.functionSign;
                    if (!this.selectedPluginConfigData.blockchainFunction.inParameters
                    && this.functionData.inParameters && this.functionData.inParameters.length) {
                        delete this.functionData.inParameters[0].variableName;
                        delete this.functionData.inParameters[0].variableValue;
                    }
                    if (!this.selectedPluginConfigData.blockchainFunction.outParameters
                    && this.functionData.outParameters && this.functionData.outParameters.length) {
                        delete this.functionData.outParameters[0].variableName;
                        delete this.functionData.outParameters[0].variableValue;
                    }
                }
                if (this.selectedPluginConfigData && this.selectedPluginConfigData.blockchainFunction) {
                    const dataObject = {};
                    dataObject.contractId = this.selectedPluginConfigData.blockchainFunction.contractId;
                    dataObject.functionId = this.selectedPluginConfigData.blockchainFunction.id;
                    if (this.selectedPluginConfigData.blockchainFunction.inParameters) {
                        dataObject.request = this.prepareResponseRequest(this.selectedPluginConfigData.blockchainFunction.inParameters);
                    }
                    if (this.selectedPluginConfigData.blockchainFunction.outParameters) {
                        dataObject.response = this.prepareResponseRequest(this.selectedPluginConfigData.blockchainFunction.outParameters);
                    }
                    this.functionDataMap = dataObject;
                } else {
                    this.functionDataMap = this.selectedPluginConfigData;
                }
                this.blockchainModal = true;
            }
            this.saveDisabled = true;
        },

        selectContract(evt) {
            if (evt && evt.length) {
                this.$root.$emit("showCheckedSaveBtn", false);
                this.contract = evt;
                if (this.selectedPluginConfigData) {
                    this.selectedPluginConfigData.contractId = this.contract;
                    if (this.selectedPluginConfigData.blockchainFunction) {
                        this.selectedPluginConfigData.blockchainFunction.contractId = this.contract;
                    } else {
                        this.selectedPluginConfigData.blockchainFunction = { contractId: this.contract };
                    }
                }
            }
        },

        selectFunction(evt) {
            if (evt && evt.length) {
                this.$root.$emit("showCheckedSaveBtn", false);
                this.func = evt;
                const findFunction = this.functionsForDdl.find(el => el.value === this.func);
                if (findFunction) {
                    this.functionData = findFunction.functionSign;
                }
                if (this.selectedPluginConfigData) {
                    this.selectedPluginConfigData.functionId = this.func;
                    this.selectedPluginConfigData.blockchainFunction.id = this.func;
                }
            }
        },

        prepareRequestResponse(value, param) {
            const obj = {}; let
                objToMap = {};
            if (param === "request") {
                this.mappedArrayRequest = [];
                this.requestNoMap = false;
            } else {
                this.mappedArrayResponse = [];
            }
            for (let i = 0; i < value.length; i++) {
                obj[value[i].id] = value[i].variableName;
                objToMap = {
                    index: i,
                    parameterId: value[i].id,
                    variableName: value[i].variableName,
                    variableValue: value[i].variableName && value[i].variableValue ? value[i].variableValue : value[i].variableName
                };

                if (param === "request") {
                    this.mappedArrayRequest.push(objToMap);
                    if (!objToMap.variableName) {
                        this.requestNoMap = true;
                    }
                } else {
                    this.mappedArrayResponse.push(objToMap);
                }
            }
            return obj;
        },

        selectPlugin(val) {
            const selectData = val || this.selectedPluginConfigData;
            if (selectData.functionId && !this.func) {
                this.func = selectData.functionId;
            }
            if (selectData.contractId && !this.contract) {
                this.contract = selectData.contractId;
            }
            if (selectData.description && !this.description) {
                this.description = selectData.description;
            }
            if (selectData.blockchainFunction && selectData.blockchainFunction.contractId && selectData.blockchainFunction.id) {
                this.contract = selectData.blockchainFunction.contractId;
                this.func = selectData.blockchainFunction.id;
            }
        }

    }
};

